export default "__VITE_ASSET__DrXSsyaL__"